import { defineComponent, useCssVars, unref, openBlock, createElementBlock, normalizeClass, renderSlot, onMounted, createElementVNode, createBlock, withCtx, createVNode, ref, createCommentVNode, toDisplayString, Teleport, Transition, normalizeStyle } from 'vue';
import { b as ReviewList, M as MainRating, d as useTailwindTheme, u as useTextDirection, f as useInlinerWidth, c as ProvidersInfo, P as PropertyRanking, R as RecordGrid } from './useTailwindTheme.DuMV2zVC.js';
import { _ as _export_sfc, u as useTheme, g as useTimeoutFn, M as Modal, A as ActionButton, e as _export_sfc$1, a as useI18n } from '../review.es.js';

const _hoisted_1$3 = ["disabled"];
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    appearance: { default: "outline" },
    disabled: { type: Boolean },
    colorScheme: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "69df0f8b": _ctx.$props.colorScheme.main,
      "7b1459bc": _ctx.$props.colorScheme.main || unref(theme).actionColor.base,
      "5b5c6226": _ctx.$props.colorScheme.text || unref(theme).actionColor.contrasted,
      "49634480": _ctx.$props.colorScheme.over || unref(theme).actionColor.over,
      "69e24eff": _ctx.$props.colorScheme.text
    }));
    const props = __props;
    const theme = useTheme();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: normalizeClass([
          "btn",
          `btn--${props.appearance}`
        ]),
        disabled: props.disabled
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 10, _hoisted_1$3);
    };
  }
});

const Button = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["__scopeId", "data-v-eba72d72"]]);

const _hoisted_1$2 = { class: "collapse__inner" };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "Collapse",
  props: {
    modelValue: { type: Boolean, default: false },
    animationDuration: { default: "0.5s" },
    direction: { default: "vertical" },
    autoOpen: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "2a849078": props.animationDuration
    }));
    const props = __props;
    const emit = __emit;
    onMounted(() => {
      if (props.autoOpen) {
        useTimeoutFn(() => {
          emit("update:modelValue", true);
        }, 0);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "collapse__main",
          props.direction === "vertical" ? "collapse__main--vertical" : "collapse__main--horizontal",
          { "collapse__main--open": props.modelValue }
        ])
      }, [
        createElementVNode("div", _hoisted_1$2, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ])
      ], 2);
    };
  }
});

const Collapse = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-0e2dfc19"]]);

const _hoisted_1$1 = { class: "reviews-header order-first" };
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "ReviewsModal",
  props: {
    config: {}
  },
  emits: [
    "close"
  ],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "5f2c277b": unref(theme).backgroundColor.washed
    }));
    const props = __props;
    const emit = __emit;
    const theme = useTheme();
    const tailwindTheme = useTailwindTheme();
    function close() {
      emit("close");
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Modal), {
        "show-close": false,
        "z-index": _ctx.$props.config.calculate.tooltip.zIndex,
        class: normalizeClass([
          "w-full sm:w-3/4 md:w-4/6 xl:w-1/2 max-w-[640px] max-h-[80vh] min-h-[26rem] flex flex-col root",
          { rtl: props.config.isRightAlign }
        ]),
        onClose: close
      }, {
        default: withCtx(() => [
          createVNode(ReviewList, {
            reviews: props.config.payload.reviews,
            "review-languages": props.config.payload.reviewLanguages
          }, null, 8, ["reviews", "review-languages"]),
          createElementVNode("div", _hoisted_1$1, [
            createVNode(MainRating, {
              data: props.config.payload.reviewAverages,
              colors: {
                darkText: unref(tailwindTheme).colors.grey[900],
                lightText: unref(tailwindTheme).colors.grey[500]
              },
              "text-style": {
                score: {
                  size: "16px",
                  weight: "400"
                },
                average: {
                  size: "32px",
                  weight: "400"
                },
                note: {
                  size: "14px",
                  weight: "600"
                },
                based: {
                  size: "12px",
                  weight: "400"
                }
              },
              tooltip: {
                ...props.config.calculate.tooltip,
                placement: "top"
              },
              orientation: "horizontal",
              class: "flex-1"
            }, null, 8, ["data", "colors", "tooltip"]),
            createVNode(unref(ActionButton), {
              type: "close",
              "over-color": unref(theme).backgroundColor.base,
              onActionClick: close,
              "data-testid": "close-modal"
            }, null, 8, ["over-color"])
          ])
        ]),
        _: 1
      }, 8, ["z-index", "class"]);
    };
  }
});

const ReviewsModal = /* @__PURE__ */ _export_sfc$1(_sfc_main$1, [["__scopeId", "data-v-852e39e8"]]);

const _hoisted_1 = { class: "root__inner" };
const _hoisted_2 = { class: "module providerRating" };
const _hoisted_3 = { class: "providerRating__score" };
const _hoisted_4 = { class: "providerRating__max" };
const _hoisted_5 = {
  key: 1,
  class: "module cta flex justify-end shrink-0"
};
const _hoisted_6 = { class: "text-sm" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "InlineReview",
  props: {
    config: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "ebda1c98": unref(width),
      "5b04a296": unref(theme).borderRadius,
      "a28b9bbe": unref(theme).backgroundColor.base,
      "27059ce0": unref(theme).borderColor,
      "22a2531e": unref(theme).backgroundColor.contrasted
    }));
    const props = __props;
    const theme = useTheme();
    const { t } = useI18n();
    const showWidget = ref(false);
    const textDirection = useTextDirection(props.config.isRightAlign);
    const modalOpen = ref(false);
    const width = useInlinerWidth({
      width: props.config.deviceStyleConfig.extra?.width,
      widthUnit: props.config.deviceStyleConfig.extra?.widthUnit
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Collapse), {
        modelValue: showWidget.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => showWidget.value = $event),
        "auto-open": "",
        role: "region",
        "aria-label": unref(t)("Review Summary"),
        class: "root"
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            createElementVNode("div", {
              class: normalizeClass([
                "root widget widget--inline",
                { "widget--bordered": unref(theme).border }
              ]),
              "data-testid": "widget"
            }, [
              createElementVNode("div", {
                class: normalizeClass([
                  "module mainRating separator",
                  props.config.isRightAlign ? "separator--before" : "separator--after"
                ])
              }, [
                createVNode(MainRating, {
                  data: _ctx.config.payload.reviewAverages,
                  colors: {
                    darkText: unref(theme).backgroundColor.contrasted,
                    lightText: unref(theme).backgroundColor.contrasted
                  },
                  orientation: "horizontal",
                  "show-info-btn": "",
                  "text-style": {
                    score: {
                      size: "16px",
                      weight: "400"
                    },
                    average: {
                      size: "32px",
                      weight: "400"
                    },
                    note: {
                      size: "14px",
                      weight: "600"
                    },
                    based: {
                      size: "12px",
                      weight: "400"
                    }
                  },
                  tooltip: {
                    ...props.config.calculate.tooltip,
                    placement: "top"
                  },
                  class: "mainRating__content"
                }, {
                  providersInfo: withCtx(() => [
                    createVNode(ProvidersInfo, {
                      data: props.config.calculate.providers,
                      direction: unref(textDirection),
                      "text-style": {
                        score: {
                          weight: "400"
                        }
                      }
                    }, null, 8, ["data", "direction"])
                  ]),
                  _: 1
                }, 8, ["data", "colors", "tooltip"])
              ], 2),
              props.config.calculate.rankingConfig.visible ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass([
                  "module ranking separator",
                  props.config.isRightAlign ? "separator--before" : "separator--after"
                ])
              }, [
                createVNode(PropertyRanking, {
                  config: props.config.calculate.rankingConfig,
                  "hightlight-color": unref(theme).actionContrastColor.base,
                  inline: "",
                  class: "ranking__content"
                }, null, 8, ["config", "hightlight-color"])
              ], 2)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_2, [
                createVNode(unref(RecordGrid), {
                  items: props.config.calculate.providers.slice(0, 5),
                  direction: "row"
                }, {
                  value: withCtx(({ item }) => [
                    createElementVNode("span", _hoisted_3, toDisplayString(item.value.score), 1),
                    createElementVNode("span", _hoisted_4, " /" + toDisplayString(item.value.max), 1)
                  ]),
                  _: 1
                }, 8, ["items"])
              ]),
              props.config.showReviews ? (openBlock(), createElementBlock("div", _hoisted_5, [
                createVNode(unref(Button), {
                  onClick: _cache[0] || (_cache[0] = ($event) => modalOpen.value = true),
                  "color-scheme": {
                    main: unref(theme).actionContrastColor.base,
                    text: unref(theme).actionContrastColor.base
                  },
                  class: "trigger text-sm",
                  "data-testid": "read-reviews"
                }, {
                  default: withCtx(() => [
                    createElementVNode("span", _hoisted_6, toDisplayString(unref(t)("Read Reviews")), 1)
                  ]),
                  _: 1
                }, 8, ["color-scheme"])
              ])) : createCommentVNode("", true),
              (openBlock(), createBlock(Teleport, {
                to: props.config.modalRootContainer ?? "body"
              }, [
                createVNode(Transition, { name: "fade" }, {
                  default: withCtx(() => [
                    modalOpen.value ? (openBlock(), createBlock(ReviewsModal, {
                      key: 0,
                      config: _ctx.config,
                      onClose: _cache[1] || (_cache[1] = ($event) => modalOpen.value = false),
                      style: normalizeStyle({ "z-index": _ctx.$props.config.zIndex })
                    }, null, 8, ["config", "style"])) : createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 8, ["to"]))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "aria-label"]);
    };
  }
});

const InlineReview = /* @__PURE__ */ _export_sfc$1(_sfc_main, [["__scopeId", "data-v-fbdbadfe"]]);

export { InlineReview as default };
//# sourceMappingURL=InlineReview.OGPAgpcc.js.map
